var exports = {
  "n": "x0a7806d5--3fafdf--link",
  "l": "x0a7806d5--3fafdf--link-name",
};

module.exports = exports;
